import { i18n } from '@/i18n/i18n';

let errorCode = {
    401: () => i18n.t('utils.request.401'),
    403: () => i18n.t('utils.request.403'),
    404: () => i18n.t('utils.request.404'),
    default: () => i18n.t('utils.request.default'),
};

export default errorCode;
